/**
 * View component for /content-modules/:contentModuleId/preview/:nodeId
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

// import utilities
import filterUtils from '../../../global/utils/filterUtils';
import progressUtils from '../../../global/utils/progressUtils';
import videoUtils from "../../../global/utils/videoUtils.js";

// import actions
// import * as courseActions from '../../course/courseActions';
import * as metricActions from '../../metric/metricActions';
// import * as moduleCertificateActions from '../../moduleCertificate/moduleCertificateActions';
import * as nodeActions from '../../node/nodeActions';
import * as resourceLinkActions from '../../resourceLink/resourceLinkActions';
import * as sceneActions from '../../scene/sceneActions';
import * as contentModuleActions from '../contentModuleActions';
import * as transitionActions from '../../transition/transitionActions';
// import * as userNodeActions from '../../userNode/userNodeActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import CloseWrapper from '../../../global/components/helpers/CloseWrapper.js.jsx';
import Modal from '../../../global/components/modals/Modal.js.jsx';
import VideoPlayer from "../../../global/components/helpers/VideoPlayer.js.jsx";

// import contentModule components
import SceneContent from '../../scene/components/SceneContent.js.jsx';
import ScenePDF from '../../scene/components/ScenePDF.js.jsx';
import SceneVideo from '../../scene/components/SceneVideo.js.jsx';
import ContentModuleLayout from '../components/ContentModuleLayout.js.jsx';
import ContentModuleNodeNav from '../components/ContentModuleNodeNav.js.jsx';
import ContentModuleTableOfContents from '../components/ContentModuleTableOfContents.js.jsx';

// import contentModule css modules
import contentModuleStyles from '../contentModuleModuleStyles.css';

// not updating links here because this should no longer be used with athens handling training and previews as of a long time ago

class AdminContentModulePreview extends Base {
  constructor(props) {
    super(props);

    this.state = {
      followupsVisible: false
      // for tracking viewing "sessions". as long as they don't leave or refresh the page, this should stay unchanged.
      , session: Math.floor(Math.random()*16777215).toString(16)
      , tocVisible: false
      , player: {}
      , replayModalOpen: false
    }

    this._bind(
      '_goBack'
      , '_handleReady'
      , '_onNodeClick'
      , '_toggleTOC'
      , '_toggleFollowups'
    )
  }

  componentDidMount() {
    const { loggedInUser, dispatch, match } = this.props;
    // tm - node view
    dispatch(contentModuleActions.fetchSingleIfNeeded(match.params.contentModuleId)).then(tmAction => {
      dispatch(resourceLinkActions.fetchListIfNeeded('contentModule', tmAction.item._id));
      dispatch(nodeActions.fetchListIfNeeded('_contentModule', tmAction.item._id, 'checkpoint', true )).then((checkpointNodeAction)=> {
        let sceneIds = checkpointNodeAction.list && checkpointNodeAction.list.length > 0 ? checkpointNodeAction.list.map(node => node._scene) : [];
        dispatch(sceneActions.fetchListIfNeeded("_id", sceneIds));
      });
    });
    // node - single
    dispatch(nodeActions.fetchSingleIfNeeded(match.params.nodeId)).then((singleNodeAction) => {
      if(singleNodeAction.success) {
        dispatch(resourceLinkActions.fetchListIfNeeded('_scene', singleNodeAction.item._scene));
        // 1.21 - current metrics for admin
        dispatch(metricActions.fetchListIfNeeded('_id', singleNodeAction.item._metrics))
        // current scene
        dispatch(sceneActions.fetchSingleIfNeeded(singleNodeAction.item._scene)).then((singleSceneAction) =>{
          // check if scene has video or pdf.  if not, show followups
          if(singleSceneAction.success) {
            if(singleSceneAction.item && !singleSceneAction.item.videoPath && !singleSceneAction.item.pdfPath) {
              this.setState({followupsVisible: true});
            }
          } else if(singleNodeAction.item._scene === undefined) {
            alert("ERROR: There is no scene associated with this node.")
          } else {
            alert(`ERROR: ${singleSceneAction.error}`)
          }
        });
      } else {
        alert(`ERROR: ${singleNodeAction.error}`)
      }
    });
    // transition - list for single node (_startNode)
    dispatch(transitionActions.fetchListIfNeeded("_startNode", match.params.nodeId)).then((transitionAction) => {
      if(transitionAction.success) {
        let endNodeIds = transitionAction.list.map(transition => transition._endNode);
        // find all _endNodes - list
        dispatch(nodeActions.fetchListIfNeeded("_id", endNodeIds)).then((endNodeAction) => {
          // scene(s) of all _endNodes - list
          let sceneIds = endNodeAction.list && endNodeAction.list.length > 0 ? endNodeAction.list.map(node => node._scene) : [];
          dispatch(sceneActions.fetchListIfNeeded("_id", sceneIds));
        });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch } = this.props;
    const { match } = nextProps;
    if(match.params.nodeId !== this.props.match.params.nodeId) {
      // invalidate selected and lists so we can refetch
      dispatch(nodeActions.invalidateSelected());
      dispatch(sceneActions.invalidateSelected());
      dispatch(nodeActions.fetchSingleIfNeeded(match.params.nodeId)).then((singleNodeAction) => {
        // 1.21 - current metrics for admin
        dispatch(metricActions.fetchListIfNeeded('_id', singleNodeAction.item._metrics))

        // current
        dispatch(sceneActions.fetchSingleIfNeeded(singleNodeAction.item._scene)).then((singleSceneAction) => {
          // check if scene has video or pdf.  if not, show followups
          dispatch(resourceLinkActions.fetchListIfNeeded('scene', singleNodeAction.item._scene));
          if(!singleSceneAction.item.videoPath && !singleSceneAction.item.pdfPath) {
            this.setState({followupsVisible: true});
          }
        });
      });
      // transition - list for single node (_startNode)
      dispatch(transitionActions.fetchListIfNeeded("_startNode", match.params.nodeId)).then((action) => {
        let endNodeIds = action.list.map(transition => transition._endNode);
        // find all _endNodes - list
        dispatch(nodeActions.fetchListIfNeeded("_id", endNodeIds)).then((action) => {
          // scene(s) of all _endNodes - list
          let nodeSceneIds = action.list && action.list.length > 0 ? action.list.map(node => node._scene) : [];
          dispatch(sceneActions.fetchListIfNeeded("_id", nodeSceneIds));
        });
      });
    }
  }

  _handleReady(playerId) {
    // console.log('player ready')
    const player = window.jwplayer(playerId);
    // console.log(player);
    // player.play();
    this.setState({player})
  }

  _toggleTOC() {
    this.setState({
      tocVisible: !this.state.tocVisible
    });

  }

  _goBack() {
    this.props.history.goBack();
  }

  _toggleFollowups() {
    // console.log(this.state.player.getState())
    if(this.state.player && this.state.player.getState && this.state.player.getState() === "playing") {
      setTimeout(()=>{
        this.state.player.pause();
      }, 250)
    }
    this.setState({
      followupsVisible: !this.state.followupsVisible
    });
  }
  _onNodeClick(nodeId) {
    this.setState({followupsVisible: false})
    this.props.dispatch(sceneActions.invalidateSelected());
  }

  render() {
    const {
      courseStore
      , loggedInUser
      , location
      , match
      , metricStore
      , moduleCertificateStore
      , nodeStore
      , resourceLinkStore
      , sceneStore
      , contentModuleStore
      , transitionStore
      , userNodeStore
    } = this.props;
    const { replayModalOpen } = this.state;

    /**
     * use the selected.getItem() utility to pull the actual contentModule object from the map
     */
    const selectedCourse = courseStore.selected.getItem();
    const selectedContentModule = contentModuleStore.selected.getItem();
    const selectedNode = nodeStore.selected.getItem();
    const selectedScene = sceneStore.selected.getItem();
    const transitions = transitionStore.util.getList("_startNode", match.params.nodeId);
    const transitionList = transitionStore.lists._startNode ? transitionStore.lists._startNode[match.params.nodeId] : null;
    const isEmpty = (
      !selectedContentModule
      || !selectedContentModule._id
      || contentModuleStore.selected.didInvalidate
      // || courseStore.selected.isFetching
      // || !courseStore.selected.id
      // || !selectedCourse
      // || !selectedCourse._id
      || !sceneStore.selected.id
      || !selectedNode
      || !selectedNode._id
      || !selectedScene
      || !selectedScene._id
      || !transitions
      || !transitionList
    );
    // const isEmpty = true;

    const isFetching =(
      contentModuleStore.selected.isFetching
      || !transitionList
      || transitionList.isFetching
      || nodeStore.selected.isFetching
      // || courseStore.selected.isFetching
      || sceneStore.selected.isFetching
    )

    let checkpointNodes = [];
    let endNodes = null;
    let previouslyViewedNodes = [];
    let previouslyViewedNodeIds = [];

    let courseResourceLinks = [];
    let sceneResourceLinks = [];
    let studyResourceLinks = [];
    let tmResourceLinks = [];

    let nextScenes = null;
    let cpScenes = null;
    let sortedNodes;
    let progressCount;
    let progressPercent = 0;
    if(!isEmpty) {
      // resource links
      // courseResourceLinks = resourceLinkStore.util.getList('_course', courseStore.selected.id);
      sceneResourceLinks = resourceLinkStore.util.getList('scene', selectedNode._scene);
      studyResourceLinks = selectedCourse ? resourceLinkStore.util.getList('study', selectedCourse._group) : null;
      tmResourceLinks = resourceLinkStore.util.getList('contentModule', selectedContentModule._id);

      // get follow up nodes & scenes
      let endNodeIds = transitions.map(transition => transition._endNode);
      endNodes = nodeStore.util.getList("_id", endNodeIds) || null;
      let nodeSceneIds = endNodes && endNodes.length > 0 ? endNodes.map(node => node._scene) : [];
      nextScenes = sceneStore.util.getList("_id", nodeSceneIds) || null;

      // look for checkpoint nodes
      checkpointNodes = nodeStore.util.getList("_contentModule", selectedContentModule._id, "checkpoint", true);
      let cpNodeSceneIds = checkpointNodes && checkpointNodes.length > 0 ? checkpointNodes.map(node => node._scene) : [];
      cpScenes = sceneStore.util.getList("_id", cpNodeSceneIds) || null;
    }

    // get progress
    progressCount = progressUtils.getProgressCount(checkpointNodes, previouslyViewedNodes);

    if(endNodes) {
      sortedNodes = selectedNode.randomizeFollowUps ? filterUtils.randomizeOrder(endNodes) : filterUtils.sortByOrderWeight(endNodes);
    }

    let arrowClass = classNames(
      "-arrow menu-toggle"
      , { '-open': this.state.followupsVisible }
    )
    let sceneClass = classNames(
      "tm-scene-wrapper"
      , {
        '-toc-open': this.state.tocVisible
        , '-toc-closed': !this.state.tocVisible
      }
    )
    let tocClass = classNames(
      "-toc menu-toggle"
      , { '-open': this.state.tocVisible }
    )
    let progressClass = classNames(
      `progress-bar-${progressPercent}`
    )
    let vidFollowClass = classNames(
      "vid-followup-wrapper test"
      , {
        '-show-video': selectedScene && selectedScene.videoPath && !this.state.followupsVisible
      }
    )
    let pdfFollowClass = 'pdf-followup-wrapper'

    return (
      <ContentModuleLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              { isEmpty ?
                  (
                    isFetching ?
                      <div className="u-centerText">
                        <div className="loading"></div>
                      </div>
                    :
                      <div className="u-centerText">
                        <h2>Ooops! No simulation found!</h2>
                        <p>Please <Link to="/contact-us">contact</Link> your administrator if you feel this was an error.</p>
                        <p>Or navigate back to your <Link to="/my-agenda">Studies</Link> and select another study!</p>
                      </div>
                  )
                :
                <div style={{ opacity: isFetching ? 0.5 : 1, width: "100%" }}>
                  <div className="yt-row space-between">
                    <div className="back-link" onClick={this._goBack}><i className="ion ion-arrow-left-c"/> Back</div>
                    { selectedNode ?
                      <div>
                          <Link to={`/cm-builder/${selectedNode._contentModule}?selectedNode=${selectedNode._id}`} className="yt-btn small info link" target="_blank">
                            Go to node map <i className="fa fa-external-link"/>
                          </Link>
                          <Link to={`/admin/authoring/content-modules/${selectedNode._contentModule}`} className="yt-btn small info link" target="_blank">
                            Go to content module <i className="fa fa-external-link"/>
                          </Link>
                          <Link to={`/admin/authoring/scenes/${selectedNode._scene}`} className="yt-btn small info link" target="_blank">
                            Go to scene <i className="fa fa-external-link"/>
                          </Link>
                          {
                            selectedNode._metrics.map(metricId => 
                              <a key={metricId} href={`${window.authoringUrl}/metrics/${metricId}`} className="yt-btn small info link" target="_blank">
                                Metric: {metricStore.byId[metricId] ? `${metricStore.byId[metricId].order} - ${metricStore.byId[metricId].title}` : "loading "}  <i className="fa fa-external-link"/>
                              </a>
                            )
                          }
                      </div>
                    :
                      null
                    }
                  </div>
                  <div className="scene-controls">
                    <div className={tocClass} onClick={this._toggleTOC}>
                      <div className="-icons">
                        <i className="-bars fal fa-bars fa-2x"/>
                        <i className="-close fal fa-times fa-2x"/>
                      </div>
                    </div>
                    <div className="yt-col">
                      <div className="checkpoint-markers">
                        <ReactTooltip
                          aria-haspopup='true'
                          className="yt-tooltip"
                          id={`tm-progress`}
                          place="top"
                          type="dark"
                          >
                            <p>{progressCount && progressCount.true ? progressCount.true : 0} of {checkpointNodes ? checkpointNodes.length : 'N/A'} checkpoints reached</p>
                        </ReactTooltip>
                        <div className="node-progress-wrapper" data-tip data-for={`tm-progress`}>
                          <div className={progressClass}>
                            <div className="-progress">
                              <div className="-complete">
                              </div>
                            </div>
                          </div>
                        </div>
                        { selectedContentModule.testable ?
                          <span
                            className="-marker"
                            onClick={this._startEvaluation}
                            >
                            <ReactTooltip
                              aria-haspopup='true'
                              className="yt-tooltip"
                              id={`tm-evaluation`}
                              place="top"
                              type="dark"
                            >
                                <p>Evaluation</p>
                            </ReactTooltip>
                            <div className="-icon" >
                              <i className="far fa-clipboard-list fa-lg" />
                            </div>
                            <div className="-super" data-tip data-for={`tm-evaluation`} >
                              <i className="fal fa-clipboard-list fa-lg"/>
                            </div>
                          </span>
                          :
                          null
                        }
                      </div>
                    </div>
                    <div className={arrowClass} onClick={this._toggleFollowups}>
                      <i className="-icon fas fa-chevron-right" />
                    </div>
                  </div>
                  <div className="yt-row stretch">
                    <ContentModuleTableOfContents
                      hideFollowUps={() => this.setState({followupsVisible: false})}
                      previouslyViewedNodeIds={[]}
                      selectedContentModule={selectedContentModule}
                      visible={this.state.tocVisible}
                    />
                    <div className="yt-col">
                      <div className={selectedScene.videoPath ? vidFollowClass : pdfFollowClass}>
                        { selectedScene && selectedScene.videoPath ?
                          <SceneVideo
                            autoPlay={true}
                            courseId={selectedCourse ? selectedCourse._id : null}
                            handleReady={this._handleReady}
                            scene={selectedScene}
                            openFollowups={() => this.setState({followupsVisible: true})}
                            contentModuleId={selectedContentModule._id}
                          />
                          :
                          selectedScene.pdfPath ?
                          <ScenePDF
                            courseId={selectedCourse ? selectedCourse._id : null}
                            openFollowups={() => this.setState({followupsVisible: true})}
                            scene={selectedScene}
                            contentModuleId={selectedContentModule._id}
                            hidden={this.state.followupsVisible}
                          />
                          :
                          null
                        }
                        <ContentModuleNodeNav
                          courseSlug={match.params.courseSlug}
                          currentNode={selectedNode}
                          currentScene={selectedScene}
                          nodes={sortedNodes}
                          onNodeClick={this._onNodeClick}
                          previouslyViewedNodeIds={[]}
                          replayVideo={() => this.setState({replayModalOpen: true})}
                          reviewPDF={() => this.setState({followupsVisible: false})}
                          scenes={nextScenes}
                          contentModule={selectedContentModule}
                          visible={this.state.followupsVisible}
                        />
                      </div>
                      <div id="resources" className="content-container scene-content-wrapper">
                        <SceneContent
                          courseResourceLinks={courseResourceLinks}
                          scene={selectedScene}
                          sceneResourceLinks={sceneResourceLinks}
                          studyResourceLinks={studyResourceLinks}
                          tmName={selectedContentModule.title}
                          tmResourceLinks={tmResourceLinks}
                        />
                      </div>
                    </div>
                  </div>
                  <Modal
                    btnColor="info"
                    cardSize='jumbo'
                    closeAction={() => this.setState({replayModalOpen: false})}
                    isOpen={replayModalOpen}
                    modalClasses={'info'}
                    modalHeader={selectedScene.title}
                    showButtons={false}
                  >
                    <VideoPlayer
                      adminPreview={false}
                      controls={true}
                      isAutoPlay={true}
                      onVideoComplete={() => console.log('done playing')}
                      playerId={selectedScene._id + '-modal'}
                      playlist={videoUtils.returnPlaylist(selectedScene.videoPath, selectedScene.posterPath, null)}
                      tracking={{
                        _course: selectedCourse ? selectedCourse._id : null
                        , _contentModule: selectedContentModule._id
                        , _scene: selectedScene._id
                        , _node: match.params.nodeId
                        , description: selectedCourse ? 'user-node-replay' : 'user-node-replay-agenda'
                      }}
                    />
                  </Modal>
                </div>
              }
            </div>
          </section>
        </div>
      </ContentModuleLayout>
    )
  }
}

AdminContentModulePreview.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    courseStore: store.course
    , loggedInUser: store.user.loggedIn.user
    , defaultUserNode: store.userNode.defaultItem
    , metricStore: store.metric
    , moduleCertificateStore: store.moduleCertificate
    , nodeStore: store.node
    , resourceLinkStore: store.resourceLink
    , sceneStore: store.scene
    , contentModuleStore: store.contentModule
    , transitionStore: store.transition
    , userNodeStore: store.userNode
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminContentModulePreview)
);



// WEBPACK FOOTER //
// modules/contentModule/views/AdminContentModulePreview.js.jsx